export { default } from './SectionChallenges';